export default {
  hasPowerBiAccess (state) {
    return state.reports.length > 0
  }
}
